module.exports = __webpack_public_path__ + "img/schema_selle_1a.3b8ef9c3.svg";